// Copyright (c) 2016 Deere & Company

import Modal from '../../../product/shared/state/modal';
import actions from '../../actions-list';
import {getDefaultState} from '../state/preferences';

const updateConfirmSaveModalVisibility = (state, action) =>
    Modal.update(state, {
        isVisible: {
            $set: action.isVisible
        }
    });

export default (state = getDefaultState().confirmSaveModal, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_PREFERENCES_CONFIRM_SAVE_MODAL_VISIBILITY]: updateConfirmSaveModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/user/shared/reducers/confirm-save-modal.js